import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SubscriptionSuccess from './SubscriptionSuccess';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(SubscriptionSuccess);

export default connect(
  mapStateToProps,
)(Styled);
